<template>
  <div class="service" :id="mtype">
    <img :src="require('@/assets/pic/service/'+mtype+'.png')" />
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
    data (n) {
      this.mtype = n.type
    },
    "$route": {
      handler (n) {
        if(n.query.stype)
          this.mtype = n.query.stype
      }
    }
  },
  data () {
    return {
      mtype: ''
    }
  },
  methods: {
   
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service {
  background: #F7F8F8 ;
  overflow: hidden;
  text-align: center;
}
.service img {
  width: 15.32rem;
  margin-top: .5rem;
  margin-bottom: .99rem;
}


</style>
